// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1sQNQ","bigColWidth":"Table_bigColWidth__1iMUF","biggerColWidth":"Table_biggerColWidth__kmoeq","row":"Table_row__1tnou","col":"Table_col__3_GyR"};